import { get } from 'aws-amplify/api';
import { isCdkProxyConfigured } from '../lib/appConfig';
import { fetchCdkProxy } from '../lib/cdkProxy';

const amplifyGet = async (path) => {
  const { body } = await get({ apiName: 'nuatalker', path }).response;
  return body.json();
};

const viaAmplify = (callApi, { path, method = 'get', body }) => {
  if (callApi) {
    return callApi({ apiName: 'nuatalker', path, method, body });
  }
  if (String(method).toLowerCase() !== 'get') {
    throw new Error('Falta callApi para mutar clientes por Amplify');
  }
  return amplifyGet(path);
};

const viaCdk = ({ hubSpotId, method, body }) =>
  fetchCdkProxy({
    service: 'clients',
    hubSpotId,
    path: '',
    method,
    body,
  });

const viaProxy = (cdkCall, amplifyCall) =>
  isCdkProxyConfigured() ? cdkCall() : amplifyCall();

/** GET /clients/all */
export function listAllClients(callApi) {
  return viaProxy(
    () => viaCdk({ hubSpotId: 'all', method: 'GET' }),
    () => viaAmplify(callApi, { path: '/clients/all', method: 'get' }),
  );
}

/** GET /clients/{hubSpotId} */
export function getClientById(hubSpotId, callApi) {
  return viaProxy(
    () => viaCdk({ hubSpotId, method: 'GET' }),
    () =>
      viaAmplify(callApi, {
        path: `/clients/${hubSpotId}`,
        method: 'get',
      }),
  );
}

/** POST /clients/new */
export function createClient(body, callApi) {
  return viaProxy(
    () => viaCdk({ hubSpotId: 'new', method: 'POST', body }),
    () => viaAmplify(callApi, { path: '/clients/new', method: 'post', body }),
  );
}

/** PATCH /clients/{hubSpotId} */
export function updateClient(hubSpotId, body, callApi) {
  return viaProxy(
    () => viaCdk({ hubSpotId, method: 'PATCH', body }),
    () =>
      viaAmplify(callApi, {
        path: `/clients/${hubSpotId}`,
        method: 'patch',
        body,
      }),
  );
}

/** DELETE /clients/{hubSpotId} */
export function deleteClient(hubSpotId, callApi) {
  return viaProxy(
    () => viaCdk({ hubSpotId, method: 'DELETE' }),
    () =>
      viaAmplify(callApi, {
        path: `/clients/${hubSpotId}`,
        method: 'delete',
      }),
  );
}
